import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import FAIcon from "./FAIcon/FAIcon";
const CharacterCounter = ({ characters, characterLimit, customUnderMessage, customOverMessage, }) => {
    const numCharacters = typeof characters === "string" ? characters.length : characters;
    const isOver = numCharacters > characterLimit;
    let message;
    if (isOver) {
        const charactersOver = numCharacters - characterLimit;
        message = customOverMessage
            ? customOverMessage(charactersOver)
            : `${charactersOver} character${charactersOver === 1 ? "" : "s"} over limit (${characterLimit})`;
    }
    else {
        const charactersUnder = characterLimit - numCharacters;
        message = customUnderMessage
            ? customUnderMessage(charactersUnder)
            : `${charactersUnder} character${charactersUnder === 1 ? "" : "s"} remaining`;
    }
    return (_jsxs("div", { children: [_jsx(FAIcon, { icon: isOver ? "exclamation-triangle" : "check", addMarginRight: true, className: isOver ? "text-danger" : "text-success" }), _jsx("span", { className: isOver ? "text-danger" : "", children: message })] }));
};
export default CharacterCounter;
